import {
	OPERATIONAL_EVENT_TYPE,
	SCREEN_EVENT_TYPE,
	TRACK_EVENT_TYPE,
	UI_EVENT_TYPE,
} from '@atlaskit/analytics-gas-types';

import type { ScreenAnalyticsPayload, NonScreenAnalyticsPayload } from '../types';

import type { FireAnalyticsPayload } from './analyticsHooks';
import type { CommonAttributes } from './commonAttributes';

type CustomNonScreenAnalyticsPayload = Omit<NonScreenAnalyticsPayload, 'eventType'>;

type CustomScreenAnalyticsPayload = Omit<ScreenAnalyticsPayload, 'eventType'>;

export class BaseInvitePeopleAnalytics {
	private readonly fireAnalytics: FireAnalyticsPayload;
	protected readonly commonAttributes!: CommonAttributes;

	constructor(fireAnalytics: FireAnalyticsPayload, attributes: CommonAttributes) {
		this.fireAnalytics = fireAnalytics;
		this.setCommonAttributes(attributes);
	}

	setCommonAttributes(attributes: CommonAttributes) {
		(this.commonAttributes as CommonAttributes) = attributes;
	}

	protected fireUI(payload: CustomNonScreenAnalyticsPayload) {
		this.fireAnalytics({ ...payload, eventType: UI_EVENT_TYPE });
	}

	protected fireTrack(payload: CustomNonScreenAnalyticsPayload) {
		this.fireAnalytics({ ...payload, eventType: TRACK_EVENT_TYPE });
	}

	protected fireOperational(payload: CustomNonScreenAnalyticsPayload) {
		this.fireAnalytics({ ...payload, eventType: OPERATIONAL_EVENT_TYPE });
	}

	protected fireScreen(payload: CustomScreenAnalyticsPayload) {
		this.fireAnalytics({ ...payload, eventType: SCREEN_EVENT_TYPE });
	}
}

export type AnalyticsClassConstructor<Instance extends BaseInvitePeopleAnalytics> = new (
	fireAnalytics: FireAnalyticsPayload,
	commonAttributes: CommonAttributes,
) => Instance;
